export default defineAppConfig({
  ui: {
    colors: {
      primary: 'teal',
    },
  },
})
